import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { tap, finalize } from 'rxjs/operators';
import { RestActivityHandlerService } from '../rest-activity-handler.service';
import { RestErrorHandlerService } from '../rest-error-handler.service';
import type { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import type { Observable } from 'rxjs';

@Injectable()
export class RestActivityInterceptor implements HttpInterceptor {

  constructor(@Inject(RestActivityHandlerService) private restActivityHandlerService: RestActivityHandlerService,
              @Inject(RestErrorHandlerService) private restErrorHandlerService: RestErrorHandlerService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.restActivityHandlerService.start();
    return next.handle(request).pipe(
      finalize((): void => this.restActivityHandlerService.complete()),
      tap(undefined,
        (error: unknown): void => {
          if (error instanceof HttpErrorResponse) {
            this.restErrorHandlerService.error(error);
          }
        }));
  }
}
